import {
	AnyRoute,
	createRootRoute,
	createRoute,
	createRouter,
} from '@tanstack/react-router';

import { basepath } from '@/constants';
import config from '@/config';

import IssueView from '@/views/issue/Issue';
import { issueSearchSchema } from '@/views/issue/Issue.hooks';
import { AUTH_KEY } from '@/views/home/auth/Authentication.hooks';
import Drafts from '@/views/drafts/Drafts';
import { NotFound, RootRouteComponent } from '@/views/RootRoute';

import { Home } from './home/Home';
import { Logout } from './auth/Logout';
import { Auth } from './auth/Auth';
import { logOut } from './auth/Auth.hooks';
import { Callback } from './callback/Callback';
import { callbackSearchSchema } from './callback/Callback.hooks';

const onClickLogout = localStorage.getItem(AUTH_KEY)
	? () => {
			logOut('/logout');
	  }
	: undefined;

/* Routes declaration */

const rootRoute = createRootRoute({
	component: RootRouteComponent,
});

const indexRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: '/',
	component: () => {
		return (
			<Auth>
				<Home onClickLogOut={onClickLogout} />
			</Auth>
		);
	},
});

const issueRoute = createRoute({
	getParentRoute: () => rootRoute,
	component: () => {
		return (
			<Auth>
				<IssueView onClickLogOut={onClickLogout} />
			</Auth>
		);
	},
	validateSearch: issueSearchSchema,
	path: 'issues/$id',
});

const issueArticleRoute = createRoute({
	getParentRoute: () => issueRoute,
	component: () => {
		return (
			<Auth>
				<IssueView onClickLogOut={onClickLogout} />
			</Auth>
		);
	},
	validateSearch: issueSearchSchema,
	path: '$articleId',
});

const callbackRoute = createRoute({
	getParentRoute: () => rootRoute,
	component: Callback,
	validateSearch: callbackSearchSchema,
	path: 'callback',
});

const logOutRoute = createRoute({
	getParentRoute: () => rootRoute,
	component: Logout,
	path: 'logout',
});

const draftsRoute = createRoute({
	getParentRoute: () => rootRoute,
	component: Drafts,
	path: 'drafts',
});

/* END of routes declaration */

const routes: Array<AnyRoute> = [
	indexRoute,
	issueRoute,
	issueArticleRoute,
	callbackRoute,
	logOutRoute,
];

if (config?.app?.admin) {
	routes.push(draftsRoute);
}

const routeTree = rootRoute.addChildren(routes);

export const router = createRouter({
	routeTree,
	basepath,
	defaultNotFoundComponent: NotFound,
});
